import { X } from "lucide-react";
import type { TagBadgeProps } from "./types";

export function TagBadge({
  name,
  color,
  onRemove,
  onClick,
  className = "",
}: TagBadgeProps) {
  const Component = onClick ? "button" : "span";

  return (
    <Component
      type={onClick ? "button" : undefined}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] text-primary ${className}`}
      style={{
        cursor: onClick ? "pointer" : undefined,
        backgroundColor: `${color}1A`,
        borderWidth: 1,
        borderColor: `${color}33`,
      }}
      onClick={
        onClick
          ? (e: React.MouseEvent) => {
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
      disabled={!onClick}
    >
      <span
        className="w-2.5 h-2.5 rounded-full"
        style={{ backgroundColor: color }}
      />
      {name}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="hover:opacity-70 transition-opacity ml-0.5"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </Component>
  );
}
